import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ContentContext } from "../contexts/ContentContext";
import { FiArrowRight } from "react-icons/fi";

/**
 * Slim homepage banner — announces Healthy Cola as a new flagship product
 * and routes to the full showcase on /products#healthy-cola.
 */
export default function HealthyColaCallout() {
    const { data } = useContext(ContentContext);
    const hc = data.healthyCola;
    const ui = data.healthyColaUi || {};
    if (!hc) return null;

    return (
        <section className="py-14 md:py-16 bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <Link
                    to="/products#healthy-cola"
                    className="group relative block overflow-hidden rounded-3xl shadow-glow text-white"
                    style={{
                        background:
                            "radial-gradient(circle at 12% 0%, rgba(255,210,51,0.25), transparent 50%), radial-gradient(circle at 88% 100%, rgba(140,198,63,0.25), transparent 55%), linear-gradient(135deg, #1a1147 0%, #0f0a2e 60%, #1a1147 100%)",
                    }}
                >
                    <div className="absolute inset-0 brand-pattern-light opacity-20 pointer-events-none" />
                    <div className="relative grid md:grid-cols-12 gap-6 items-center p-6 md:p-10">
                        <div className="md:col-span-7 lg:col-span-8">
                            <div className="flex flex-wrap items-center gap-2.5 mb-3">
                                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold-400 text-navy-900 text-[10px] font-bold tracking-[0.22em] uppercase">
                                    <span className="w-1.5 h-1.5 rounded-full bg-navy-900 motion-safe:animate-shimmer" />
                                    {hc.eyebrow}
                                </div>
                                <div className="inline-flex items-center px-2 py-1 rounded-full bg-white/95 border border-white/30">
                                    <img
                                        src="/images/saudi-made.svg"
                                        alt={ui.saudiMadeAlt || "Saudi Made"}
                                        className="h-4 w-auto"
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                            <h3 className="font-serif text-2xl md:text-4xl font-bold text-white leading-tight mb-2">
                                {ui.calloutTitle}
                            </h3>
                            <p className="text-white/80 text-sm md:text-base max-w-2xl mb-4">
                                {ui.calloutSubtitle}
                            </p>
                            <span className="inline-flex items-center gap-2 text-sm font-semibold text-gold-300 group-hover:gap-3 transition-all">
                                {ui.calloutLink}
                                <FiArrowRight className="rtl:rotate-180" />
                            </span>
                        </div>
                        <div className="md:col-span-5 lg:col-span-4">
                            {hc.lineupImage && (
                                <img
                                    src={hc.lineupImage}
                                    alt={ui.imageAlt || "Healthy Cola"}
                                    loading="lazy"
                                    className="w-full h-auto rounded-2xl border border-white/15 shadow-soft"
                                    onError={(e) => (e.currentTarget.style.display = "none")}
                                />
                            )}
                        </div>
                    </div>
                </Link>
            </div>
        </section>
    );
}
